/**
 * Beyond Card Types enums based on Docecbo learning types or Beyond course offerings
 */
export enum CardType {
  BEYONDCX = 'Beyond CX',
  CERTIFICATION_EXAM = 'Certification Exam',
  COURSE = 'Course',
  COURSE_SESSION = 'Course Session',
  FLEXIBLE_METHODS_OF_LEARNING = 'Flexible Methods of Learning',
  LEARNING_PATH = 'Learning Path', // TODO: Will be implemented in Beyond 3.x future
  SUBSCRIPTION = 'Subscription', // Same thing as Learning Plan
}
